module.exports = __webpack_public_path__ + "static/media/hubspotProcess2.c31c97e1.png";